import { checklistClient } from '../../config/api';
import {
  Section,
  SectionApiResponse,
  SectionsApiResponse,
  AddSectionRequest,
  UpdateSectionRequest,
} from '../types/checklist.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

export class SectionService {
  private readonly basePath = '/api/groups';

  getAllSections = async (groupId: string): Promise<Section[]> => {
    try {
      const response = await checklistClient.get<SectionsApiResponse>(
        `${this.basePath}/${groupId}/sections`
      );

      if (!response.data || !response.data.success) {
        throw new Error(response.data?.errorMessage || 'Error fetching sections');
      }

      return response.data.data || [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching sections');
    }
  };

  getSectionById = async (groupId: string, sectionId: string): Promise<Section> => {
    try {
      const response = await checklistClient.get<SectionApiResponse>(
        `${this.basePath}/${groupId}/sections/${sectionId}`
      );

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error fetching section');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error fetching section');
    }
  };

  addSection = async (groupId: string, data: AddSectionRequest): Promise<Section> => {
    try {
      const response = await checklistClient.post<SectionApiResponse>(
        `${this.basePath}/${groupId}/sections`,
        data
      );

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error adding section');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error adding section');
    }
  };

  updateSection = async (
    groupId: string,
    sectionId: string,
    data: UpdateSectionRequest
  ): Promise<Section> => {
    try {
      const response = await checklistClient.put<SectionApiResponse>(
        `${this.basePath}/${groupId}/sections/${sectionId}`,
        data
      );

      if (!response.data || !response.data.success || !response.data.data) {
        throw new Error(response.data?.errorMessage || 'Error updating section');
      }

      return response.data.data;
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error updating section');
    }
  };

  deleteSection = async (groupId: string, sectionId: string): Promise<void> => {
    try {
      const response = await checklistClient.delete<SectionApiResponse>(
        `${this.basePath}/${groupId}/sections/${sectionId}`
      );

      if (response.data && !response.data.success) {
        throw new Error(response.data?.errorMessage || 'Error deleting section');
      }
    } catch (error: unknown) {
      apiErrorHandler(error, 'Error deleting section');
    }
  };
}

export const sectionService = new SectionService();
